import { useTranslation } from 'react-i18next'
import { ErrorAlert } from '@repo/ui'
import SimpleApplyCancelDialog from '@/components/common/dialog/SimpleApplyCancelDialog'
import { Abruftoken } from '@/models/Abruftoken'
import useBfnAbweisenMutation from '@/features/befehlsnachrichten/mutations/useBfnAbweisenMutation'

export interface BfnAbweisenDialogProps {
  abruftoken: Abruftoken
  state: boolean
  onClose: () => void
  'data-testid': string
}

export default function BfnAbweisenDialog({
  abruftoken,
  state,
  onClose,
  'data-testid': testId
}: Readonly<BfnAbweisenDialogProps>) {
  const { t } = useTranslation('bfnDetails')
  const { mutation } = useBfnAbweisenMutation(abruftoken)

  const onApply = () => {
    mutation.mutate(undefined, {
      onSuccess: () => {
        onClose()
      }
    })
  }

  return (
    <SimpleApplyCancelDialog
      title={t('dialog.abweisen.title')}
      state={state}
      onApply={onApply}
      onCancel={onClose}
      applyButtonDisabled={mutation.isPending}
      applyButtonText={t('dialog.abweisen.apply')}
      cancelButtonText={t('dialog.abweisen.cancel')}
      data-testid={testId}
    >
      <p data-testid={`${testId}-text`}>{t('dialog.abweisen.text')}</p>
      <p className="font-bold" data-testid={`${testId}-warning`}>
        {t('dialog.abweisen.warning')}
      </p>
      {mutation.isError && (
        <>
          <ErrorAlert error={mutation.error} data-testid={`${testId}-error`}>
            {t('dialog.abweisen.error')}
          </ErrorAlert>
          <p className="text-red-500" data-testid={`${testId}-contact-fdl`}>
            {t('dialog.abweisen.contact_fdl')}
          </p>
        </>
      )}
    </SimpleApplyCancelDialog>
  )
}
